'use strict';
var isRegExp = require('../internals/is-regexp');

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/not-a-regexp.js
// module id = 353
// module chunks = 0